var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlRoomForConcertsFilled = function SvgHtlRoomForConcertsFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m4.884 13.975-.02.023-.1-.082a.519.519 0 0 1-.059-.046l-.009-.009-2.013-1.594-.043-.026a.5.5 0 0 1-.126-.695l4.095-5.917a.5.5 0 0 1 .915.285.5.5 0 0 1-.088.284l-.232.335a2.958 2.958 0 0 0 2.033 1.532l.235-.262a.5.5 0 1 1 .746.668l-4.8 5.359a.5.5 0 0 1-.373.167.499.499 0 0 1-.161-.022Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.814 8.527a3.232 3.232 0 0 1-2.019-.7 3.266 3.266 0 0 1-.661-4.422l.588 1.031.016.027a6.861 6.861 0 0 0 3.311 2.571l1.211.393a3.263 3.263 0 0 1-2.446 1.1Zm3-1.973-1.433-.465a5.916 5.916 0 0 1-2.8-2.164l-.725-1.273A3.283 3.283 0 0 1 9.817 2a3.266 3.266 0 0 1 2.997 4.552v.002Z"
  })));
};
export default SvgHtlRoomForConcertsFilled;